import React, { createContext, useState, useEffect } from 'react';
import { useLocalStorage } from '../hooks/useLocalStorage';
import { useAuth } from '../hooks/useAuth';
import axios from 'axios'
export const CityContext = createContext(null);

export const CityProvider = ({ children }) => {
    const { user } = useAuth()
    const [city, setCity] = useLocalStorage('city', 0);
    const [cities, setCities] = useLocalStorage('cities', []);
    const [citiesIsLoading, setCitiesIsLoading] = useState(true)
    const [citiesAdmin, setCitiesAdmin] = useState([]);
    const [citiesAdd, setCitiesAdd] = useState([]);
    // const belarusianCities = [
    //     { id: 0, name: "Полоцк-Новополоцк" },
    //     { id: 8, name: "Борисов" },
    //     { id: 5, name: "Брест" },
    //     { id: 4, name: "Витебск" },
    //     { id: 7, name: "Гомель" },
    //     { id: 12, name: "Гродно" },
    //     { id: 11, name: "Жодино" },
    //     { id: 3, name: "Интернет-магазин" },
    //     { id: 15, name: "Лида" },
    //     { id: 9, name: "Минск" },
    //     { id: 6, name: "Могилёв" },
    //     { id: 17, name: "Мозырь" },
    //     { id: 2, name: "Новополоцк" },
    //     { id: 10, name: "Пинск" },
    //     { id: 1, name: "Полоцк" },
    //     { id: 14, name: "Слуцк" },
    //     { id: 13, name: "Солигорск" }
    // ];

    function updateCity(city) {
        setCity(city);
    }
    useEffect(() => {
        const fetchCities = async () => {
            const response= await axios.get(`https://elated-turing.178-124-131-24.plesk.page/city/all`);
            if (response) {
                let citiesFlat = response.data.flatMap(country => country.cities);
                citiesFlat.unshift({ id: 0, name: "Полоцк-Новополоцк" })

                setCities(citiesFlat);
                setCitiesIsLoading(false)
            }
        };

        fetchCities();
    }, []);

    useEffect(() => {
        if (citiesIsLoading) return
        if (user) {
            const currentCities = user.data.idCity === -1
                ? cities
                : cities.find(item => item.id === user.data.idCity);

            setCities(currentCities instanceof Array ? currentCities : [currentCities]);
            setCitiesAdmin(cities.concat([{ id: -1, name: "Все" }]));

            setCitiesAdd(user.data.idCity === -1
                ? cities.slice(1)
                : (user.data.idCity === 0
                    ? [{ id: 2, name: "Новополоцк" }, { id: 1, name: "Полоцк" }]
                    : [currentCities])
            );
        } else {
            setCities([]);
            setCitiesAdmin([]);
            setCitiesAdd([]);
        }
    }, [user, citiesIsLoading]);

    return (
        <CityContext.Provider value={{ city, updateCity, cities, citiesAdmin, citiesAdd }}>
            {children}
        </CityContext.Provider>
    );
};